import React, {ReactElement} from "react";
import {Button, ButtonProps, MenuItem, Select, Tooltip, Typography} from "@mui/material";
import {FONT_SIZES, PageElement, PageElementType, TEXT_ALIGN_KTM, TextAttributes} from "@/smilebook-shared/types";
import {StyledBoxColumn, StyledBoxRowWithLabel} from "@/shared/StyledComponents";
import FontPicker from "./FontPicker";
import {BaseApp} from "@/shared/BaseApp";
import {HexColorPicker} from "react-colorful";
import {Debouncer} from "@/shared/file_util";

const colorDebouncer = new Debouncer(200);

function TextAlignButton(props: ButtonProps & { selected?: boolean }): ReactElement {
  return <Button
    variant={props.selected ? "contained" : null}
    {...props}
    style={{
      flexGrow: 1,
      ...props.style,
    }}>
                 {props.children}
  </Button>;
}

export function SidebarContentText(props: {
  selectedElement: PageElement,
  selectedTextAttributes: TextAttributes,
  setSelectedTextAttributes: (attributes: TextAttributes) => void
}): ReactElement {
  return props.selectedElement?.type === PageElementType.TEXT || props.selectedElement?.type === PageElementType.SUBTEXT
    ? <StyledBoxColumn>
      <StyledBoxRowWithLabel label={"Alignment"}>
        {TEXT_ALIGN_KTM.values.map(value => <Tooltip title={value.metadata.text}>
          <TextAlignButton
            selected={value.key === props.selectedTextAttributes?.textAlign}
            onClick={() => {
              props.setSelectedTextAttributes(Object.assign(props.selectedTextAttributes || new TextAttributes(), {textAlign: value.key}));
            }}
          >
            <value.metadata.iconType/>
          </TextAlignButton>
        </Tooltip>)}
      </StyledBoxRowWithLabel>
      <StyledBoxRowWithLabel label={"Font"}>
        <FontPicker
          activeFontFamily={props.selectedTextAttributes?.fontFamily}
          onChange={(nextFont) => {
            props.setSelectedTextAttributes(Object.assign(props.selectedTextAttributes || new TextAttributes(), {fontFamily: nextFont.family}));
          }}
        />
      </StyledBoxRowWithLabel>
      <StyledBoxRowWithLabel label={"Size"}>
        <Select
          variant={"outlined"}
          size={"small"}
          value={props.selectedTextAttributes?.fontSize.toString()}
          onChange={(e) => {
            props.setSelectedTextAttributes(Object.assign(props.selectedTextAttributes || new TextAttributes(), {fontSize: Number.parseInt(e.target.value)}));
          }}>
          {FONT_SIZES.map(size => <MenuItem value={size.toString()}>{size.toString()}</MenuItem>)}
        </Select>
      </StyledBoxRowWithLabel>
      <StyledBoxRowWithLabel label={"Color"}>
        <Button
          onClick={(e) => {
            BaseApp.CONTEXT.showPopover(e.target as HTMLElement, {
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "center"
              }
            }, () => <HexColorPicker color={props.selectedTextAttributes?.fontFamily} onChange={color => {
              colorDebouncer.run(() => {
                props.setSelectedTextAttributes(Object.assign(props.selectedTextAttributes || new TextAttributes(), {color}));
              })
            }}/>);
          }}
          style={{padding: 8}} variant={"outlined"}>
          <div style={{width: 48, aspectRatio: 2, background: props.selectedTextAttributes?.color}}/>
        </Button>
      </StyledBoxRowWithLabel>
    </StyledBoxColumn>
    : <Typography>No element selected, or selected element is not text.</Typography>
}